import { Activityeditor, SupplierActivity } from '@linktivity/gds-neo';

const TemplateStatus = Activityeditor.TemplateStatus;
type TemplateStatus = Activityeditor.TemplateStatus;

const BookingType = Activityeditor.BookingType;
type BookingType = Activityeditor.BookingType;

const SalesStatus = Activityeditor.SalesStatus;
type SalesStatus = Activityeditor.SalesStatus;

const PublishTarget = SupplierActivity.PublishTarget;
type PublishTarget = SupplierActivity.PublishTarget;

export { TemplateStatus, SalesStatus, BookingType, PublishTarget };
export * from './supplierAccount/const';
export * from './supplierLegacy/const';
export * from './supplierBooking/const';
export * from './supplierVoucher/const';
export * from './supplierFinance/const';
